<template>
    <div>
        <base-modal ref="modal" size="xl" :loading="modalLoading" :centered="true" @closed="modalClosedCb()">
            <template>
                <div class="mx-2 my-2">
                    <div v-for="(category, index) in panelTypeCategories" :key="index">
                        <!-- Category header -->
                        <div class="d-flex" v-if="category.panelTypes.length">
                            <div class="flex-grow-1">
                                <div class="font-weight-bold mb-3">{{ category.name }}</div>
                            </div>
                            <div class="flex-grow-0" v-if="index === 0">
                                <button type="button" class="close d-flex align-items-center" data-dismiss="modal"
                                    aria-label="Close" style="">
                                    <span class="icon icon-glyphicons-basic-menu-close align-middle"
                                        style="font-size: 20px"></span>
                                </button>
                            </div>
                        </div>
                        <!-- Grid list of panel types -->
                        <div class="grid" style="margin-bottom: 50px;">
                            <div class="card h-100 panel-type-card rounded-lg position-relative" :class="{
                                'panel-type-card-active': panel.panel_type == panelType.value,
                                'panel-type-card-disabled': panelType.disabled,
                                'panel-type-card-available': !panelType.disabled,
                            }" v-for="panelType in category.panelTypes" :key="panelType.value"
                                @click="selectPanelType(panelType)">
                                <div class="card-body panel-type-card-body d-flex align-items-center">
                                    <panel-type-display :panel-type="panelType"></panel-type-display>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-light btn-sm" type="button" data-dismiss="modal"
                    @click="cancel()">Cancel</button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from "@/components/BaseModal"
import PanelTypeDisplay from "@/components/PanelTypeDisplay"
import { panelTypes } from "@/assets/js/settings.js"

export default {
    name: "PanelTypeSelector",
    components: {
        BaseModal,
        PanelTypeDisplay,
    },
    data() {
        return {
            panel: {},
            modalLoading: false,
            panelWasSelected: false,
        }
    },
    computed: {
        freeTierActive() {
            return this.$store.getters.freeTierActive
        },
        readOnly() {
            return this.$store.getters.caseIsReadOnly
        },
        createIsDisabled() {
            return this.modalLoading || this.readOnly || !this.panel.panel_type
        },
        userDetails() {
            return this.$store.getters.user
        },
        // The full list of available panel types the user can choose from.
        availablePanelTypes() {
            let availablePanelTypes = [...panelTypes]
            if (this.panel.id) {
                // Special case - for existing panel types, don't allow switching to vitals panel.
                // This is because vitals panels are initialized differently.
                availablePanelTypes = availablePanelTypes.filter(p => p.panel_type !== 'vitals')
            }
            if (this.panel.show_video_first) {
                // If a video is being shown first, only allow panel types that are compatible with
                // pre-content videos.
                availablePanelTypes = availablePanelTypes.filter(p => p.allowPreContentVideo)
            }
            return availablePanelTypes
        },
        // A list of the panel type categories (there are currently 3), including the list
        // of available panel types associated with each one.
        panelTypeCategories() {
            return [
                {
                    name: "Display",
                    panelTypes: this.availablePanelTypes.filter(p => p.category === "display")
                },
                {
                    name: "Interactive",
                    panelTypes: this.availablePanelTypes.filter(p => p.category === "interactive")
                },
                {
                    name: "More",
                    panelTypes: this.availablePanelTypes.filter(p => p.category === "other")
                },
            ]
        },
    },
    methods: {
        // Open the create panel modal.
        open(panel = null) {
            this.panelWasSelected = false
            if (panel) {
                this.panel = panel
            }
            this.$refs.modal.show()
        },
        hide() {
            this.$refs.modal.hide()
        },
        selectPanelType(panelType) {
            if (panelType.disabled) {
                return
            }
            this.panelWasSelected = true
            this.$emit("selected", {
                panel_type: panelType.value
            })
        },
        modalClosedCb() {
            if (!this.panelWasSelected) {
                this.$emit("closed")
            }
        },
        cancel() {
            this.$emit("cancelled")
        },
    },
    beforeDestroy() {
        // Remove event listeners on the modal.
        this.$refs.modal.removeListeners()
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/paneledit.scss";

.grid {
    display: grid;
    gap: 1.25rem;
    grid-template-columns: repeat(2, 1fr);

    @media (min-width: $breakpoint-sm) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: $breakpoint-md) {
        grid-template-columns: repeat(4, 1fr);
    }
}
</style>